module.exports = __webpack_public_path__ + "static/media/scott_bench.8c8fdaef.png";